// LMS-5183: customer-api duplicate checks (searchCustomers with duplication: true) now search the
// whole company and mask every hit the caller cannot open to
// { id, contact: { id, has_srb_account? }, duplicate_out_of_scope: true }.
// The name, identity numbers, mobile, email and owner of such a customer are never returned.
export const isOutOfScopeDuplicate = (customer) => !!(
  customer && customer.duplicate_out_of_scope === true
);

// A contact is linked to an SRB account when it carries an srb_id, or, for a masked duplicate,
// when customer-api reports has_srb_account instead of the srb_id itself.
export const hasSRBAccount = (contact) => !!(
  contact && (contact.srb_id || contact.has_srb_account === true)
);
